<template>
  <ModalCard>
    <template #custom>
      <div class="py-5 iframe-container">
        <iframe
          title="Privacy policy"
          class="iframe-box is-full-width is-full-height"
          :src="src"
          :data-e2e="ModalCypressAttribute.preview_pdf.views.IFRAME"
        />
      </div>
    </template>
  </ModalCard>
</template>

<script>
import { ModalCypressAttribute } from '@/modules/core/app/constants/ModalCypressAttribute';
import ModalCard from '/@/modules/core/ui/components/ModalCard.vue';
import { ContactUsInfoMixin } from '@/modules/auth/mixins/ContactUsInfoMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'PrivacyPolicyModal',
  mixins: [ContactUsInfoMixin],
  components: { ModalCard },
  props: {
    policySrc: {
      type: String
    }
  },
  static: {
    ModalCypressAttribute
  },
  computed: {
    src() {
      return this.policySrc ?? this.privacyPolicy;
    }
  }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 60px);
}
</style>
